/**
 * Whether the page is hidden or on its way out.
 *
 * `document.visibilityState` alone is not enough: a browser can abort in-flight requests on
 * `pagehide` before the visibility state flips, so those failures would still read as foreground.
 * The flag is raised on `pagehide` and on a change to hidden, and cleared when the page is visible
 * again.
 */
let isBeingHidden = false;

const syncWithVisibility = () => {
    isBeingHidden = document.visibilityState === 'hidden';
};

if (typeof window !== 'undefined') {
    document.addEventListener('visibilitychange', syncWithVisibility);
    window.addEventListener('pageshow', syncWithVisibility);
    window.addEventListener('pagehide', () => {
        isBeingHidden = true;
    });
}

const isPageHidden = (): boolean => isBeingHidden || document.visibilityState === 'hidden';

export default isPageHidden;
